import { motion } from 'framer-motion';
import type { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

/** Shared animated page wrapper for consistent screen transitions. */
export function Screen({ children, className = '' }: PropsWithChildren<{ className?: string }>) {
  return (
    <motion.main
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.25, ease: 'easeOut' }}
      className={`mx-auto min-h-dvh w-full max-w-5xl px-4 pb-24 pt-6 ${className}`}
    >
      {children}
    </motion.main>
  );
}

/** Top bar with back navigation and title. */
export function TopBar({ title, backTo }: { title: string; backTo?: string }) {
  return (
    <header className="mb-6 flex items-center gap-3">
      {backTo && (
        <Link
          to={backTo}
          aria-label="Back"
          className="glass flex h-10 w-10 items-center justify-center rounded-full text-lg transition hover:bg-white/10"
        >
          ←
        </Link>
      )}
      <h1 className="text-xl font-bold tracking-tight">{title}</h1>
    </header>
  );
}

/** Placeholder body used by screens that are fleshed out in later phases. */
export function ComingSoon({ phase, note }: { phase: number; note: string }) {
  return (
    <div className="glass flex flex-col items-center justify-center gap-2 rounded-3xl p-12 text-center">
      <span className="text-3xl">🚧</span>
      <p className="font-semibold">Coming in Phase {phase}</p>
      <p className="max-w-sm text-sm text-white/60">{note}</p>
    </div>
  );
}
